<template>&nbsp;</template>
<script lang="ts" setup>
definePage({
  // needed for outdated external urls still pointing to /account/info
  redirect: { name: '/account/profile/' },
})
</script>
